export default __webpack_public_path__ + "static/media/logoCropped.200c754a.png";